import Config from "next_report/config"
import { SeriesOptionsType } from "highcharts"

export default (
  chart_categories: string[],
  series: SeriesOptionsType[],
  percent: boolean = false,
  title: string | null = null,
  labels_disenable: boolean = false,
  tooltips = null
) => {
  let max
  if (percent) {
    max = 100
  }
  return Config.baseChart(percent, series, {
    chart: { type: "bar" },
    title: {
      text: title,
      y: 180,
      style: {
        color: "#919191",
        fontSize: "14px",
        fontWeight: "normal",
        maxWidth: "80px",
        lineHeight: "14px",
        whiteSpace: "normal",
        textAlign: "center",
      },
      floating: true,
      useHTML: true,
    },
    tooltip: {
      ...Config.chartTemplates.unstackedTooltip(percent),
      formatter(tooltip) {
        if (tooltips && tooltips[this.key]) {
          const description = tooltips[this.key]
          const defaultTT = tooltip.defaultFormatter.call(this, tooltip)
          defaultTT.push(`<br>${description}`)
          return defaultTT
        }
        return tooltip.defaultFormatter.call(this, tooltip)
      },
    },
    plotOptions: {
      bar: { dataLabels: Config.chartTemplates.dataLabels(percent) },
    },
    yAxis: {
      max: max ?? null,
    },
    xAxis: {
      categories: chart_categories,
      labels: {
        formatter () {
          const v = this.value.toString()
          if (v.includes("(EB)") || v.includes("Empfehlungsbund")) {
            return `<span style="fill: #0f353e; font-weight: bold" title='Kanal wird direkt durch Empfehlungsbund bespielt'>${this.value}</span>`
          }
          if (v.includes("(EBN)")) {
            return `<span style="fill: #206c80; font-weight: bold" title="Kanal wird indirekt/auch durch Empfehlungsbund bespielt">${this.value}</span>`
          }
          return this.value.toString()
        },
        enabled: !labels_disenable,
      },
    },
  })
}
